// Geracao de chaves Idempotency-Key para mutations POST/PATCH/DELETE.
// O backend usa essa chave para deduplicar retries (ex: usuario clica
// 2x no botao Salvar antes do toast aparecer). A chave deve ser unica
// por intencao logica do usuario (1 chave por submit, NAO por request HTTP).
//
// Espelha o mobile (`grana-money-app/src/shared/lib/idempotency.ts`).

function generateUUID(): string {
  if (typeof globalThis.crypto?.randomUUID === 'function') {
    return globalThis.crypto.randomUUID();
  }
  // Fallback determinístico — Math.random + timestamp. Suficiente para
  // dedup em janela curta (servidor descarta apos 24h).
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 11)}`;
}

/**
 * Gera uma nova `Idempotency-Key`. Use 1 chave por intencao logica de
 * mutation (1 submit do form). Retries automaticos do ky reusam a mesma
 * chave naturalmente porque o request original e clonado.
 */
export function newIdempotencyKey(): string {
  return generateUUID();
}

/**
 * Aplica a chave nos headers padrao de uma request. Conveniencia para
 * passar em options de ky: `api.post('expenses', { json, headers: idempotency() })`.
 */
export function idempotencyHeaders(key?: string): Record<string, string> {
  return { 'Idempotency-Key': key ?? newIdempotencyKey() };
}
